import { ProviderNetworkCompany } from '@sondermind/utilities/models-client-facing';

export interface BvErrorData {
  suggestedPayer?: ProviderNetworkCompany;
  memberName?: string;
  dateOfBirth?: string;
  memberId?: string;
  groupNumber?: string;
  coverageStatus?: 'active' | 'inactive' | 'unknown' | 'Active' | 'Inactive' | 'Unknown';
  errorType: string;

  failureReason?: string;
  coverageStartDate?: string;
  coverageEndDate?: string;
  insuranceName?: string;
}

export const BvErrorTypes = {
  SUGGESTED_PAYER: 'suggested_payer',
  NO_COVERAGE: 'no_coverage',
  MENTAL_HEALTH_NOT_COVERED: 'mental_health_not_covered',
  MEDICAID: 'medicaid',
  MEDICAID_PLAN: 'medicaid_plan',
  PAYOR_DOWNTIME: 'payor_downtime',
  COVERAGE_NOT_STARTED: 'coverage_not_started',
  COVERAGE_EXPIRED: 'coverage_expired',
  UNKNOWN_COSTSHARE: 'unknown_costshare',
  INSURANCE_OUT_OF_NETWORK: 'insurance_out_of_network'
} as const;

export type KnownBvErrorType = typeof BvErrorTypes[keyof typeof BvErrorTypes];

export function isKnownBvErrorType(errorType: string): errorType is KnownBvErrorType {
  return Object.values(BvErrorTypes).includes(errorType as KnownBvErrorType);
}

export interface BvErrorConfig {
  title: string;
  subtitle: string;
  primaryButtonText: string;
  secondaryLinkText?: string;
  tertiaryLinkText?: string;
  showMemberDetails?: boolean;
  showPrimaryAction?: boolean;
  showSecondaryAction?: boolean;
  showTertiaryAction?: boolean;
}
